<template>
  <div class="pt-4 pb-20 px-4">
    <ConnectExchangeAccount
        :title="$t('add_exchange_account')"
        desc=""
        @action-success="onSuccessConnectAccount"
    />
  </div>
</template>

<script>
import {addBackButton, hideBackButton} from "@/helpers/telegramHelper";
import ConnectExchangeAccount from "@/components/exchange/ConnectExchangeAccount.vue";

export default {
  components: {
    ConnectExchangeAccount,
  },

  computed: {
    isMexc() {
      return this.$user?.tariff?.tariff?.exchanges && this.$user.tariff.tariff.exchanges.indexOf('mexc') !== -1;
    },
  },

  methods: {
    onSuccessConnectAccount() {
      this.$router.push('/');
    },
  },

  data() {
    return {
      loading: true,
      error: null,
      selectedExchange: null,
      formError: {
        message: '',
        errors: null,
        status: 0,
      },
      form: {
        type_exchange: null,
        api_key: '',
        api_secret: 'none',
        api_passphrase: '',
        uid: '',
      },
      formProcessing: false,
    }
  },

  mounted() {
    this.loading = false
    addBackButton(this.$router);
  },

  beforeUnmount() {
    hideBackButton();
  }
}
</script>